import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { obtenerCotizcionesDiariosAction } from "../../../ducks/reportesCotizacionesDuck"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { makeStyles } from '@material-ui/core/styles'
import { Card, CardContent, Grid } from "@material-ui/core"
import { FormatoFecha } from "../../../utils/FormatFecha"
import GraficaBarras from "./Grafica"
import FiltroDia from "./FiltroDia"
import { dataGraficarCotizacionesAgente } from "./utils/dataGraficar"
import { DEFAULT_COLOR_BG, COLOR_BG, COLOR_BG_BORDER, DEFAULT_COLOR_BG_BORDER } from "./utils/colors"

const useStyles = makeStyles({
    main: {
        padding: "2%"
    },
    container: {
        display: "flex",
        flexFlow: "row",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
    },
    root: {
        width: '60%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    rootGrafica: {
        width: '40%',
        minWidth: 180,
        height: 460,
        marginTop: "1rem"
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 10,
        marginTop: 10,
        padding: 2
    },
})
const useReportes = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCotizcionesDiariosAction({ Fecha: FormatoFecha({ date: new Date(), formato: "MMddyyyy" }) })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
const useDataGraficarGenralMes = () => {
    const { cotizacioneAllDia, fechaMes } = useSelector(store => store.reporteCotizador)
    const copyDetalleCotizacionGlobal = cotizacioneAllDia?.lDetalleCotizacionGlobal ?? []
    const labels = [`${FormatoFecha({ date: fechaMes, formato: "MM/yyyy" })}`]
    const arrayData = copyDetalleCotizacionGlobal.map((cotizacion, index) => {
        return {
            label: `${cotizacion?.catEstatusCotizacion?.Descripcion}`,
            data: [cotizacion?.total],
            backgroundColor: COLOR_BG[cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion] || DEFAULT_COLOR_BG,
            borderColor: COLOR_BG_BORDER[cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion] || DEFAULT_COLOR_BG_BORDER
        }
    })
    let data = {
        labels,
        datasets: arrayData
    }
    return data
}

const CotizacionesDia = () => {
    const classes = useStyles()
    const { cotizacioneAllDia, fechaDia } = useSelector(store => store.reporteCotizador)
    useReportes()
    const data = useDataGraficarGenralMes()
    return (
        <>
            <Grid container style={{ margin: "1rem 0" }} alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={4}>
                    <FiltroDia />
                </Grid>
            </Grid>
            <Grid container style={{ margin: "1rem 0" }} alignItems="center" justifyContent="center" spacing={1}>
                <Grid item xs={6}>
                    <Card>
                        <CardContent>
                            <h3>Datos genrales</h3>
                            Total de cotizaciones del dia: {cotizacioneAllDia?.total}
                            {
                                cotizacioneAllDia?.lDetalleCotizacionGlobal?.sort((a, b) => {
                                    return a.catEstatusCotizacion?.IdCatEstatusCotizacion - b.catEstatusCotizacion?.IdCatEstatusCotizacion
                                })?.map((cotizacion, index) => {
                                    return (
                                        <div key={index}>
                                            {`${cotizacion?.catEstatusCotizacion?.Descripcion}: ${cotizacion?.total}`}
                                        </div>
                                    )
                                })
                            }

                            <GraficaBarras data={data} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: "1rem" }} alignItems="flex-start" justifyContent="center" spacing={1}>
                {
                    cotizacioneAllDia?.lCuentaCotizacion?.map(item => {
                        return (
                            <Grid item xs={4} key={item.cuenta?.Id_Cuenta}>
                                <Card style={{ minHeight: "430px" }}>
                                    <CardContent>
                                        <b>Agente:</b>
                                        {
                                            ` ${item.cuenta?.Nombre} ${item.cuenta?.Apellido_Paterno} ${item.cuenta?.Apellido_Materno}`
                                        }
                                        <br />
                                        {
                                            `${item.cuenta?.eMail}`

                                        }
                                        <br />
                                        Total de cotizacion del agente: {item.lDetalleCotizacion?.reduce((a, b) => a + b.total, 0)}
                                        <br />
                                        {
                                            item.lDetalleCotizacion?.sort((a, b) => {
                                                return a.catEstatusCotizacion?.IdCatEstatusCotizacion - b.catEstatusCotizacion?.IdCatEstatusCotizacion
                                            }).map(cotizacion => {
                                                return (
                                                    <div key={cotizacion?.catEstatusCotizacion?.IdCatEstatusCotizacion}>
                                                        {`${cotizacion?.catEstatusCotizacion?.Descripcion}: ${cotizacion?.total}`}
                                                    </div>
                                                )
                                            })
                                        }
                                        <GraficaBarras data={dataGraficarCotizacionesAgente({ cotizacionesAgente: item.lDetalleCotizacion, fecha: fechaDia })} />
                                    </CardContent>
                                </Card>
                            </Grid>
                        )
                    })
                }
            </Grid>
        </>
    )
}
export default CotizacionesDia